import styles from './feature_toggle.module.css';
export default function FeatureToggle(props) {
  return (
    <div
      onClick={()=>props.onChanged(!props.on)} 
      className={`${styles.featureToggle} ${props.on ? styles.toggleOn : ""}`}>
      {props.title}
    </div>
  )
}